/*
  Project: The Empowered Dancers
  Author: Marcin Ziółek
 */

import slider from './modules/slider';
import search from './modules/search';
import header from './modules/header';
import nav from './modules/nav';
import toggleText from './modules/toggle-text';
import popup from './modules/popup';
import addToCart from './modules/add-to-cart';

slider();
search();
header();
nav();
toggleText();
popup();
addToCart();



// WEBPACK FOOTER //
// ./src/scripts/app.js